import { router } from "@inertiajs/react";
import { friendshipAcceptancePath, friendshipDeclinePath, friendshipPath, friendshipsPath } from "@travily/routes";
import { useCallback } from "react";

interface FriendshipProfile {
  friendship_id: number | null;
  friendship_status?: string | null;
  handle: string;
}

/** Friendship handlers shared by the profile show and store pages. */
export function useFriendshipActions(profile: FriendshipProfile) {
  const { friendship_id, friendship_status, handle } = profile;

  const onFriendshipAction = useCallback(() => {
    if (!friendship_status || friendship_status === "none") {
      router.post(friendshipsPath(), { handle });
    }
  }, [friendship_status, handle]);

  const onAcceptFriendship = useCallback(() => {
    if (friendship_id) {
      router.post(friendshipAcceptancePath(friendship_id));
    }
  }, [friendship_id]);

  const onDeclineFriendship = useCallback(() => {
    if (friendship_id) {
      router.post(friendshipDeclinePath(friendship_id));
    }
  }, [friendship_id]);

  const onUnfriend = useCallback(() => {
    if (friendship_id) {
      router.delete(friendshipPath(friendship_id));
    }
  }, [friendship_id]);

  return { onAcceptFriendship, onDeclineFriendship, onFriendshipAction, onUnfriend };
}
